import { useQuery } from '@tanstack/react-query'
import { FormEvent, useState } from 'react'
import { Client } from '../../shared/types'
import { useObjectCreate } from '../api/object'
import { get } from '../fetch'
import { useFormLayout } from '../layouts'
import { FormLayout } from '../layouts/form-layout'
import useDebounce from '../use-debounce'
import { Button } from './button'
import { Dialog } from './dialog'
import { Input } from './input'

export function AresModal({
	ico: initialIco,
	onCreate,
	onClose,
}: {
	ico: string
	onCreate: (client: Client) => void
	onClose: VoidFunction
}) {
	const [ico, setIco] = useState(initialIco)
	const debouncedIco = useDebounce(ico, { delay: 400 })
	const { data, dataUpdatedAt } = useQuery({
		queryKey: ['api', 'client', 'search-ares', debouncedIco],
		queryFn: () => {
			const query = new URLSearchParams({ ico: debouncedIco.padStart(8, '0') })
			return get<Client>('/api/0/client/_/actions/ares/search', query)
		},
		enabled: /^\d{4,8}$/.test(debouncedIco),
	})
	const { layout } = useFormLayout('client')
	const { mutate, isPending: isCreatingPending } = useObjectCreate('client')

	const onSubmit = (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault()
		mutate?.(new FormData(event.currentTarget), {
			onSuccess: client => {
				onCreate(client as Client)
				onClose()
			},
		})
	}

	return (
		<Dialog heading="Nový objekt" isOpen onOpenChange={onClose}>
			<form className="p-4 space-y-4 m-auto max-w-[60em] w-[480px]" onSubmit={onSubmit}>
				<Input
					label="IČO"
					className="flex-auto"
					value={ico}
					onChange={setIco}
					pattern="^\d{4,8}$"
				/>
				<div className="border-b border-gray-400" />
				<FormLayout layout={layout} data={data} key={dataUpdatedAt} />
				<Button type="submit" isPending={isCreatingPending} isDisabled={isCreatingPending}>
					Uložit
				</Button>
			</form>
		</Dialog>
	)
}
